<template>

    <v-row class="image-content-center" :style="showBorder?'border: 1px solid #f0f0f0;':''">
        <v-progress-circular v-if="imageLoading" indeterminate color="deep-orange"></v-progress-circular>
        <v-hover v-else-if="imageUrl" v-slot:default="{ hover }">
        <v-img :src="imgWpx(imageUrl, 200)" class="grey lighten-4" aspect-ratio="2">
            <v-row slot="placeholder" class="image-content-center">
                <v-progress-circular indeterminate color="deep-orange"></v-progress-circular>
            </v-row>
            <v-expand-transition>
                <div v-if="hover" class="d-flex transition-fast-in-fast-out grey darken-2 v-card--reveal white--text text-caption">Change</div>
            </v-expand-transition>
        </v-img>
        </v-hover>
        <div v-else-if="icon">
            <v-icon size="36.">mdi-{{icon}}</v-icon>
        </div>
        <div v-else>
          <v-icon size="36" color="grey">mdi-account</v-icon>
        </div>
    </v-row>

</template>

<script>
import Constants from "../../Constants/Constants";
    export default {
        name: "ImageBox",
        props: {
            imageUrl: String,
            imageLoading: Boolean,
            icon: {type: String, default: ''},
            showBorder: {type: Boolean, default: true},
        },
        data(){ return{ Constants: Constants }}
    }
</script>

<style scoped>
.image-content-center{
    height: 100%;
    align-items: center!important;
    justify-content: center!important;
    margin: 0!important;
    cursor: pointer;
}
.v-card--reveal {
    align-items: center;
    bottom: 0;
    left: 0;
    justify-content: center;
    opacity: .8;
    position: absolute;
    width: 100%;
}
</style>
